import { MaterialCategory, MaterialType } from '../enum/Material';
import textureProtectionSystem from '../images/texture_protection_system.svg';
import textureRiprapArticulated from '../images/texture_riprap_articulated.svg';

export const getTextureByMaterial = (materialType: MaterialType, materialCategory: MaterialCategory): string | undefined => {
    if (materialCategory == MaterialCategory.Gabion || materialCategory == MaterialCategory.Reno || materialCategory == MaterialCategory.MacMat) {
        return textureProtectionSystem;
    } else if (materialCategory == MaterialCategory.Riprap || (materialType == MaterialType.ProtectionSystems && materialCategory == MaterialCategory.Other)) {
        return textureRiprapArticulated;
    }
};

export const getImgSrcWithColor = (texture: string, color: string): string => {
    let decodedImage = atob(texture.substring(26));
    decodedImage = decodedImage.replaceAll('currentColor', color);
    return 'data:image/svg+xml;base64,' + btoa(decodedImage);
};

export const loadImage = (imgSrc: string): Promise<HTMLImageElement> =>
    new Promise(resolve => {
        let img = new Image();
        img.src = imgSrc;
        img.onload = () => resolve(img);
    });
